import { IdNameResponse } from "services/tenantManagementService";
import { emptyArray } from "utils/commonHelper";

export const ITEMS_LIMIT = 6;
export const ITEMS_LIMIT_MULTISELECT = 8;
export const SEARCH_DEBOUNCE = 1000;

export type ItemsModel = {
	items: IdNameResponse[],
	count?: number
}

export const emptyItemsModel: ItemsModel = {
	items: emptyArray,
	count: undefined
}
